var _path, _g, _g2, _g3, _g4, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAssetServicesEmptystate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 122,
    viewBox: "0 0 128 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.5 86H89.5C107 86 114 79 114 61.5V40.5C114 23 107 16 89.5 16H68.5C51 16 44 23 44 40.5V61.5C44 79 51 86 68.5 86Z",
    fill: "url(#paint0_linear_5704_13192)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_5704_13192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.5 102H65.5C83 102 90 95 90 77.5V56.5C90 39 83 32 65.5 32H44.5C27 32 20 39 20 56.5V77.5C20 95 27 102 44.5 102Z",
    fill: "url(#paint1_linear_5704_13192)",
    fillOpacity: 0.4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_5704_13192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5 102H63.5C81 102 88 95 88 77.5V56.5C88 39 81 32 63.5 32H42.5C25 32 18 39 18 56.5V77.5C18 95 25 102 42.5 102Z",
    fill: "url(#paint2_linear_5704_13192)",
    fillOpacity: 0.16
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_5704_13192)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1572 37.1572C27.3041 33.0102 33.676 31.25 42.5 31.25H63.5C72.324 31.25 78.6959 33.0102 82.8428 37.1572C86.9898 41.3041 88.75 47.676 88.75 56.5V77.5C88.75 86.324 86.9898 92.6959 82.8428 96.8428C78.6959 100.99 72.324 102.75 63.5 102.75H42.5C33.676 102.75 27.3041 100.99 23.1572 96.8428C19.0102 92.6959 17.25 86.324 17.25 77.5V56.5C17.25 47.676 19.0102 41.3041 23.1572 37.1572ZM24.2178 38.2178C20.4898 41.9459 18.75 47.824 18.75 56.5V77.5C18.75 86.176 20.4898 92.0541 24.2178 95.7822C27.9459 99.5102 33.824 101.25 42.5 101.25H63.5C72.176 101.25 78.0541 99.5102 81.7822 95.7822C85.5102 92.0541 87.25 86.176 87.25 77.5V56.5C87.25 47.824 85.5102 41.9459 81.7822 38.2178C78.0541 34.4898 72.176 32.75 63.5 32.75H42.5C33.824 32.75 27.9459 34.4898 24.2178 38.2178Z",
    fill: "url(#paint3_linear_5704_13192)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_5704_13192)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7892 61.6054C47.7892 55.7482 52.5374 51 58.3946 51C59.6424 51 60.8431 51.2161 61.959 51.6143C62.4483 51.7889 62.814 52.2019 62.928 52.7086C63.042 53.2154 62.8885 53.7453 62.5212 54.1126L59.1221 57.5477C58.64 58.0349 58.399 58.2785 58.2854 58.5484C58.1262 58.9269 58.1274 59.3539 58.2888 59.7315C58.4039 60.0008 58.6463 60.243 59.1311 60.7274C59.6168 61.2128 59.8597 61.4555 60.1295 61.5704C60.5078 61.7315 60.9354 61.7319 61.3141 61.5716C61.5841 61.4572 61.8274 61.215 62.3141 60.7307L65.8049 57.2567C66.1672 56.8944 66.6881 56.7398 67.1894 56.8457C67.6907 56.9516 68.1045 57.3037 68.2893 57.7816C68.7488 58.9699 69 60.2601 69 61.6054C69 67.4626 64.2518 72.2108 58.3946 72.2108C57.5289 72.2108 56.6855 72.1068 55.8769 71.9098C55.4935 71.8164 55.2511 71.7576 55.0739 71.722C55.0411 71.7154 55.0143 71.7105 54.9928 71.7067C54.9872 71.7117 54.981 71.7172 54.9742 71.7233C54.8801 71.8084 54.7566 71.9312 54.5387 72.1491L45.0729 81.6149C43.2261 83.4617 40.2319 83.4617 38.3851 81.6149C36.5383 79.7681 36.5383 76.7739 38.3851 74.9271L47.8509 65.4613C48.0688 65.2434 48.1916 65.1199 48.2767 65.0258C48.3003 64.9996 48.2868 64.9702 48.278 64.9261C48.2424 64.7489 48.1836 64.5065 48.0902 64.1231C47.8932 63.3145 47.7892 62.4711 47.7892 61.6054Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_5704_13192",
    x: 0,
    y: 12,
    width: 110,
    height: 110,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_5704_13192"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_5704_13192",
    x: 2,
    y: 16,
    width: 102,
    height: 102,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5704_13192"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_5704_13192",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_5704_13192",
    x: 1.25,
    y: 15.25,
    width: 103.5,
    height: 103.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5704_13192"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_5704_13192",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_5704_13192",
    x: 37,
    y: 51,
    width: 32,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5704_13192"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5704_13192",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5704_13192",
    x1: 49,
    y1: 23,
    x2: 102,
    y2: 91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52E8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B47FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5704_13192",
    x1: 25,
    y1: 39,
    x2: 78,
    y2: 107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52E8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B47FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5704_13192",
    x1: 23,
    y1: 39,
    x2: 76,
    y2: 107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52E8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B47FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5704_13192",
    x1: 81,
    y1: 38,
    x2: 24,
    y2: 96.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0285714,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetServicesEmptystate);
export default __webpack_public_path__ + "static/media/asset-services-emptystate.4e03124d904a9e8e78d8ee8fa3efe799.svg";
export { ForwardRef as ReactComponent };